// @ts-nocheck
import { createOrderSlice } from 'pages/orderShared/createOrderSlice';

const { slice, initialState: _initialState } = createOrderSlice({
	name: 'orderByStore',
	columnKeys: ['sku', 'store', 'warehouse', 'order'],
	hasAvailability: false,
});

export const initialState = _initialState;
export default slice;

export const { setColumns, setOrderData, appendOrderData, setLoading, clearData } = slice.actions;
